import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { ProjectTypeActions } from '../actions/project-type.actions';
import { ProjectType } from '../models/project-type.model';
import { ProjectTypeService } from 'src/app/services/project-type.service';
import { StorageService } from 'src/app/services/storage.service';

export class ProjectTypeStateModel {
    is_refreshing: boolean
    project_type: ProjectType[]
}

@State<ProjectTypeStateModel>({
    name: 'project_type',
    defaults: {
        is_refreshing: true,
        project_type: []
    }
})
@Injectable()
export class ProjectTypeState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private projectTypeService: ProjectTypeService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<ProjectTypeStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                      
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {             
        if (this.storageService.is_initialized) {
            const state_model: ProjectTypeStateModel = change.currentValue      
            this.storageService.set('project_types', JSON.stringify(state_model))    
        }  
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('project_types');        
        if (json) {
            const state_model: ProjectTypeStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new ProjectTypeActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new ProjectTypeActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.projectTypeService.getAll()    
        if (objs != null) {
          const many = ProjectType.buildMany(objs)                  
          this.store.dispatch(new ProjectTypeActions.Set(many))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: ProjectTypeStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: ProjectTypeStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: ProjectTypeStateModel) {
        return state.project_type
    }

    @Action(ProjectTypeActions.Refresh)
    async refresh({patchState}: StateContext<ProjectTypeStateModel>, {  }:ProjectTypeActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(ProjectTypeActions.Init)
    init({setState, getState}: StateContext<ProjectTypeStateModel>, { payload }:ProjectTypeActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new ProjectTypeActions.Refresh())
    }
    
    @Action(ProjectTypeActions.Set)
    set({setState}: StateContext<ProjectTypeStateModel>, { payload }:ProjectTypeActions.Set) {             
        setState({   
            is_refreshing: false,         
            project_type: payload
        })
    }
}
